<ion-row>
  <ion-col size="4" size-xs="12" size-md="4" size-lg="4" class="ion-padding">
    <ion-img src="images/product/product.jpg" class="ion-padding-end">
    </ion-img>
  </ion-col>
  <ion-col
    size="8"
    size-xs="12"
    size-md="8"
    size-lg="8"
    class="text-dark ion-padding-top"
  >
    <ion-row>
      <ion-col>
        <ion-label
          class="panel-header-text ion-padding-start ion-padding-bottom"
          color="dark"
        >
          {{ 'device_infoTitle' | translate }}
        </ion-label>
      </ion-col>
    </ion-row>
    @if (isAccessExpired()) {
      <ion-row>
        <ion-col class="ion-margin-horizontal">
          <admin-core-lib-installation-no-access>
          </admin-core-lib-installation-no-access>
        </ion-col>
      </ion-row>
    } @else if (isCtdLimitReached()) {
      <ion-row>
        <ion-col class="ion-margin-horizontal">
          <admin-core-lib-installation-ctd-limit>
          </admin-core-lib-installation-ctd-limit>
        </ion-col>
      </ion-row>
    }

    <ion-row class="ion-padding-start ion-padding-top">
      <ion-col size="4">{{ 'device_serialNumber' | translate }}</ion-col>
      <ion-col size="8">{{ data().sn }}</ion-col>
    </ion-row>
    <ion-row class="ion-padding-start">
      <ion-col size="4">{{ 'list_type' | translate }}</ion-col>
      <ion-col size="8">{{ data().type }}</ion-col>
    </ion-row>
  </ion-col>
</ion-row>
